import Vue from 'vue'

import Vuex from 'vuex';

// Al momento è tutto in quest'unico file:
// import mutations from './mutations';
// import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // isLogged: false,
        loggedAs: {
            ruolo: null,
            id: null
        },
        darkMode: false,
        snackbar: {
            messaggio: null,
            tipo: null,
            isVisibile: false
        },
        dialogConferma: {
            isVisibile: false,
            titolo: null,
            testo: null,
            onAnnulla: ()=>{},
            onConferma: ()=>{}
        },
        // statusGuida: {
        //     // Possiede gli stati della guida di ogni sezione: 
        //     // - is_guida_tecnici_completa
		// 	// - is_guida_corsi_completa
		// 	// - is_guida_referenti_completa
		// 	// - is_guida_modelli_email_completa
		// 	// - is_guida_circolari_automatiche_completa
		// 	// - is_guida_email_inviate_completa
        // }
    },
    mutations: {
        // initStatusGuida(state, data){
        //     state.statusGuida = data
        // },
        // setStatusGuida(state, chiave){
        //     if(state.statusGuida[chiave] == 1)
        //         return; // Guida già visualizzata

        //     axios.get('/set_guida_completa?chiave='+chiave)
        //         .then((res)=>{
        //             state.statusGuida[chiave] = 1;
        //         })
        // },

        mostraSnack(state, { messaggio, tipo }) {
            state.snackbar.messaggio = messaggio;
            state.snackbar.tipo = tipo;
            state.snackbar.isVisibile = true;
        },
        // nascondiSnack(state) { // In realtà non serve perché è fisso a 2s
        //     state.snackbar.isVisibile = false;
        // },

        // aziona la dark mode
        toggleDarkMode(state) {     
            state.darkMode = !state.darkMode;

            if(state.darkMode){
                // Conservo info in localStorage solo se true
                localStorage.setItem('darkMode', true); // memorizza in un local storage la preferenza sulla dark mode
            } else {
                localStorage.removeItem('darkMode');
            }
        },
        loadDarkMode(state) { // Controlla se impostata preferenza della dark mode nel localStorage
            if (localStorage.getItem('darkMode') != null){
                state.darkMode = true;
            } else {
                state.darkMode = false;
            }
        },

        mostraDialogConferma(state, { titolo, testo, onConferma, onAnnulla }) {
            state.dialogConferma.titolo = titolo;
            state.dialogConferma.testo = testo;
            state.dialogConferma.onConferma = onConferma;
            state.dialogConferma.onAnnulla = onAnnulla;
            state.dialogConferma.isVisibile = true;
        },
        nascondiDialogConferma(state) {
            state.dialogConferma.titolo = null;
            state.dialogConferma.testo = null;
            state.dialogConferma.onConferma = ()=>{};
            state.dialogConferma.onAnnulla = ()=>{};
            state.dialogConferma.isVisibile = false;
        },

        // setIsLogged(state, status) {
        //     state.isLogged = status;
        // },
        login(state, {ruolo, id}){
            // state.loggedAs = {
            //     ruolo: ruolo,
            //     id: id
            // }
            // Per prendere le informazioni sulle guide già visualizzate, ricarico direttamente la pagina:
            // window.location.reload();
        },
        controllaLogin(state, callbackSuccess = null){ // Chiamato al caricamento dell'applicazione (F5) per controllare se l'utente è loggato (come admin o tecnico)
            axios.get(`/controllo_login`)
            .then(res => {
                state.loggedAs = {
                    ruolo: res.data.ruolo,
                    id: res.data.id
                }

                if(callbackSuccess)
                    callbackSuccess();
            })
        }
    },
    getters: {
        // isLogged: state => {
        //     return state.isLogged;
        // },
        loggedAs: state => {
            return state.loggedAs;
        },
    }
});